import { createFileRoute, useSearch } from '@tanstack/react-router'
import type { JSX } from 'react'

import { DeckScreen } from './-components/deck-screen.tsx'

/**
 * One Studio deck. The document is the `id` search param, read loosely so a
 * typed `validateSearch` does not narrow every `navigate` call in the app.
 */
export const Route = createFileRoute('/studio/deck')({
  component: DeckPage
})

function DeckPage(): JSX.Element {
  const search: Record<string, unknown> = useSearch({ strict: false })
  const id =
    typeof search.id === 'string' && search.id !== '' ? search.id : null
  return <DeckScreen key={id ?? 'none'} id={id} />
}
